export default __webpack_public_path__ + "static/media/background-desktop.75e7cc14.svg";